import { useNavigate, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useEffect, useState } from 'react';
import { MButton } from '@/components/ui/atoms/MButtons';
import MTopBar from '@/components/ui/atoms/MTopBar';
import MFrame from '@/components/ui/atoms/MFrame';
import { IconDatabase, IconKey } from '@tabler/icons-react';
import styles from './OnboardingInfo.module.css';
import { subscriptionService } from '@/services/subscription.service';

const OnboardingInfo = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useTranslation();
  const [trialDays, setTrialDays] = useState<number>(45);

  const isLogin = location.state?.isLogin || false;
  const passthroughState = location.state?.fromLogin ? {
    fromLogin: location.state.fromLogin,
    autoSendOtp: location.state.autoSendOtp,
    prefillEmail: location.state.prefillEmail,
    prefillMobile: location.state.prefillMobile,
    prefillDialCode: location.state.prefillDialCode,
    mode: location.state.mode,
  } : null;

  useEffect(() => {
    subscriptionService.getPublicPlans().then((plans) => {
      const trialPlan = plans.find((p) => p.type === 'trial');
      if (trialPlan?.duration) setTrialDays(trialPlan.duration);
    }).catch(() => {});
  }, []);

  const handleContinue = () => {
    if (isLogin) {
      navigate('/login/form', { state: { mode: 'mobile', isLogin: true } });
    } else {
      navigate('/register/consent', { state: passthroughState ?? undefined });
    }
  };

  const benefits = [
    {
      icon: IconDatabase,
      text: t('auth.onboarding.info.benefit1')
    },
    {
      icon: IconKey,
      text: t('auth.onboarding.info.benefit3')
    }
  ];

  const trialText = t('auth.onboarding.info.trialText', { trialDays });

  return (
    <div className={styles.onboardingPage}>
      <MTopBar
        onBack={() => navigate(-1)}
        exitPath="/"
        exitKey="exit"
        withBackground={false}
        hideProfilePicker
      />

      <div className={styles.content}>
        <h1 className={styles.title}>
          {t('auth.onboarding.info.title').split('\n').map((line, i) => (
            <span key={i}>
              {line}
              {i < t('auth.onboarding.info.title').split('\n').length - 1 && <br />}
            </span>
          ))}
        </h1>

        <MFrame className={styles.benefitsCard}>
          {benefits.map((benefit, index) => {
            const Icon = benefit.icon;
            return (
              <div key={index} className={styles.benefitItem}>
                <div className={styles.iconCircle}>
                  <Icon size={24} color="#8764BB" />
                </div>
                <p className={styles.benefitText}>
                  {benefit.text.split('\n').map((line, i) => (
                    <span key={i}>
                      {line}
                      {i < benefit.text.split('\n').length - 1 && <br />}
                    </span>
                  ))}
                </p>
              </div>
            );
          })}
        </MFrame>

        <p className={styles.trialText}>
          {trialText.split('\n').map((line, i) => (
            <span key={i}>
              {line}
              {i < trialText.split('\n').length - 1 && <br />}
            </span>
          ))}
        </p>
        <div className={styles.footer} style={{marginTop: '100px'}}>
          <MButton
            variant="filled"
            size="lg"
            onClick={handleContinue}
            className={styles.continueButton}
          >
            {t('auth.onboarding.info.continue')}
          </MButton>
        </div>
      </div>

    </div>
  );
};

export default OnboardingInfo;
